import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { IconBurger } from '~/shared/components/icons';

class TopbarSidebarButton extends PureComponent {
    static propTypes = {
        changeMobileSidebarVisibility: PropTypes.func.isRequired,
        changeSidebarVisibility: PropTypes.func.isRequired,
    };

    render() {
        const { changeMobileSidebarVisibility, changeSidebarVisibility } =
            this.props;

        return (
            <div>
                <button
                    type='button'
                    className='topbar__button topbar__button--desktop'
                    onClick={changeSidebarVisibility}
                >
                    <div className='topbar__button-icon'>
                        <IconBurger />
                    </div>
                </button>
                <button
                    type='button'
                    className='topbar__button topbar__button--mobile'
                    onClick={changeMobileSidebarVisibility}
                >
                    MENU
                    <div className='topbar__button-icon'>
                        <IconBurger />
                    </div>
                </button>
            </div>
        );
    }
}

export default TopbarSidebarButton;
